/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ countLabel: NonNullable<unknown> }} Intro_Pool_Size_Large_DescriptionInputs */

const bn_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} উচ্চতর অসুবিধা সহ।`)
};

const de_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} mit höherem Schwierigkeitsgrad.`)
};

const el_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} με μεγαλύτερη δυσκολία.`)
};

const en_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} with higher difficulty.`)
};

const es_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} con mayor dificultad.`)
};

const fr_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} avec une difficulté plus élevée.`)
};

const hi_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} अधिक कठिनाई के साथ।`)
};

const hu_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} nagyobb nehézségi fokozattal.`)
};

const id_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} dengan tingkat kesulitan yang lebih tinggi.`)
};

const it_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} con difficoltà maggiore.`)
};

const ja_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} の難易度が高くなります。`)
};

const ko_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} 난이도가 더 높습니다.`)
};

const nl_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} met hogere moeilijkheidsgraad.`)
};

const pl_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} z wyższym poziomem trudności.`)
};

const pt_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} com maior dificuldade.`)
};

const ru_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} с более высокой сложностью.`)
};

const sv_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} med högre svårighetsgrad.`)
};

const tr_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} daha yüksek zorlukla.`)
};

const uk_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} з вищою складністю.`)
};

const vi_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} với độ khó cao hơn.`)
};

const zh_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} 难度较高。`)
};

const zh_hant_intro_pool_size_large_description = /** @type {(inputs: Intro_Pool_Size_Large_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.countLabel} 難度較高。`)
};

/**
* | output |
* | --- |
* | "{countLabel} with higher difficulty." |
*
* @param {Intro_Pool_Size_Large_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_pool_size_large_description = /** @type {((inputs: Intro_Pool_Size_Large_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Pool_Size_Large_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_pool_size_large_description(inputs)
	if (locale === "de") return de_intro_pool_size_large_description(inputs)
	if (locale === "el") return el_intro_pool_size_large_description(inputs)
	if (locale === "en") return en_intro_pool_size_large_description(inputs)
	if (locale === "es") return es_intro_pool_size_large_description(inputs)
	if (locale === "fr") return fr_intro_pool_size_large_description(inputs)
	if (locale === "hi") return hi_intro_pool_size_large_description(inputs)
	if (locale === "hu") return hu_intro_pool_size_large_description(inputs)
	if (locale === "id") return id_intro_pool_size_large_description(inputs)
	if (locale === "it") return it_intro_pool_size_large_description(inputs)
	if (locale === "ja") return ja_intro_pool_size_large_description(inputs)
	if (locale === "ko") return ko_intro_pool_size_large_description(inputs)
	if (locale === "nl") return nl_intro_pool_size_large_description(inputs)
	if (locale === "pl") return pl_intro_pool_size_large_description(inputs)
	if (locale === "pt") return pt_intro_pool_size_large_description(inputs)
	if (locale === "ru") return ru_intro_pool_size_large_description(inputs)
	if (locale === "sv") return sv_intro_pool_size_large_description(inputs)
	if (locale === "tr") return tr_intro_pool_size_large_description(inputs)
	if (locale === "uk") return uk_intro_pool_size_large_description(inputs)
	if (locale === "vi") return vi_intro_pool_size_large_description(inputs)
	if (locale === "zh") return zh_intro_pool_size_large_description(inputs)
	return zh_hant_intro_pool_size_large_description(inputs)
});